import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { jotaiStore } from '@/providers/jotai/jotai-store';
import CurrentFacilityAtoms from '@/state/current-facility.state';
import { getCachedAgentSlug } from '@/utils/agent-cache';
import { DEFAULT_FEATURE } from '@/utils/routing';

export const Route = createFileRoute('/$org/')({
  beforeLoad: ({ params }) => {
    const cached = getCachedAgentSlug();

    // If we have a cached facility for this org, redirect to it
    if (cached?.orgName === params.org && cached?.shortname) {
      throw redirect({
        to: `/$org/$agent/${DEFAULT_FEATURE}`,
        params: {
          org: params.org,
          agent: cached.shortname,
        },
      });
    }

    // No cached facility for this org, redirect to root for facility selection
    throw redirect({ to: '/' });
  },
  onLeave: ({ context }) => {
    const orgId = jotaiStore.get(CurrentFacilityAtoms.organizationId);
    if (context?.queryClient && orgId) {
      // Invalidate all atlast queries for the organization
      context.queryClient.invalidateQueries({ queryKey: [orgId] });
    }
  },
  component: () => <Outlet />,
});
